module.exports = __webpack_public_path__ + "resources/img/zoom-ui-customizations-05.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-customizations-05.png
// module id = 1401
// module chunks = 0